/**
 * Natural Earth 1 projection (Patterson & Jenny 2012) —
 * pseudocylindrical, rounded, cinematic.
 *
 * Maps (lat, lng) in degrees to (x, y) in world-plane units.
 * Full-world extent: x ∈ [-2.74, 2.74], y ∈ [-1.58, 1.58].
 * Aspect ≈ 1.73:1 — close to 16:9, so the map fills a widescreen TV.
 */
export const MAP_CENTER_LNG = 18; // central/east Africa centerline

export type Vec2 = [number, number];

export function latLngToPlane(
  lat: number,
  lng: number,
  centerLng = MAP_CENTER_LNG,
): Vec2 {

  // Wrap relative longitude to (-180, 180]
  let dl = lng - centerLng;
  while (dl > 180) dl -= 360;
  while (dl <= -180) dl += 360;

  const l = (dl * Math.PI) / 180; // longitude (rad)
  const phi = (lat * Math.PI) / 180; // latitude (rad)
  const phi2 = phi * phi;
  const phi4 = phi2 * phi2;

  // The x polynomial uses φ², not l² — this narrows the map at the poles
  // so the projection tapers gracefully instead of looking rectangular.
  const x =
    l *
    (0.8707 -
      0.131979 * phi2 -
      phi2 * (0.003971 - 0.001529 * phi2));

  const y =
    phi *
    (1.007226 +
      phi2 *
        (0.015085 -
          phi2 * (0.044475 - 0.059587 * phi2 + 0.005916 * phi4)));

  return [x, y];
}

/** Threshold for detecting polygons that wrap across the antimeridian. */
export const ANTIMERIDIAN_THRESHOLD = 2.6;
